enum ErrorCode {
    UserExists = "E_USER_EXISTS"
}

export default ErrorCode
